import axios from "axios";

const baseApiUrl = process.env.REACT_APP_BASE_API;
const testApiUrl = process.env.REACT_APP_TEST_API;
const mcbApiUrl = process.env.REACT_APP_MCB_API;
const pnlURL = process.env.REACT_APP_PNL_API;
const InvestingApiUrl = process.env.REACT_APP_INVESTING_BASE_API;
const LienReportUrl = process.env.REACT_APP_LIEN_REPORT_API


export const loginApi = async (data) => {
  const url = `${baseApiUrl}/sign-in`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const signUpDashboard = async (data) => {
  const url = `${baseApiUrl}/features/register`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const getBankDetails = async (data) => {
  const url = `${baseApiUrl}/customer/bank/account?custId=${data}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const featuresList = async () => {
  const url = `${baseApiUrl}/features`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getCustomerRoles = async () => {
  const url = `${baseApiUrl}/roles/all`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getCustomerList = async ({
  username,
  partnerCode,
  startDate,
  endDate,
  accountStatus,
  nextStep,
  LIMIT = 20,
  OFFSET = 1,
}) => {
  try {
    const response = await axios.get(
      `${baseApiUrl}/customer/list?partnerCode=${partnerCode}&from=${startDate}&to=${endDate}&accountStatus=${accountStatus}&nextStep=${nextStep}&LIMIT=${LIMIT}&OFFSET=${OFFSET}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const searchCustomerList = async (username, LIMIT = 20, OFFSET = 1) => {
  try {
    const response = await axios.get(
      `${baseApiUrl}/customer/list?query=${username}&LIMIT=${LIMIT}&OFFSET=${OFFSET}`
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const getCustomerDetails = async (custId) => {
  try {
    const response = await axios.get(
      `${baseApiUrl}/customer/detail?custId=${custId}`
    );
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const addRoleToUser = async (data) => {
  const url = `${baseApiUrl}/user/add-user-role`;
  try {
    const response = await axios.put(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createFeature = async (data) => {
  const url = `${baseApiUrl}/features/add`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createRole = async (data) => {
  const url = `${baseApiUrl}/roles/register-role`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const updateRole = async (data) => {
  const url = `${baseApiUrl}/roles/update`;
  try {
    const response = await axios.patch(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createUserReportDownload = async (
  partner,
  start_date,
  end_date,
  userID
) => {
  const config = {
    headers: {
      adminid: userID,
    },
  };
  const url = `${baseApiUrl}/dashboard/user/user-report-q?partnerCode=${partner}&from=${start_date}&to=${end_date}`;
  try {
    let response = await axios.post(url, {}, config);
    return response;
  } catch {}
};

export const getUserReportDownload = async (userID, partnerId) => {
  const config = {
    headers: {
      adminid: userID,
    },
  };
  const url = `${baseApiUrl}/dashboard/user/user-report?partnerCode`;
  try {
    let response = await axios.get(url, config);
    return response;
  } catch {}
};

export const forgotPassword = async (data) => {
  const url = `${baseApiUrl}/send-otp`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const sendOtp = async (data) => {
  const url = `${baseApiUrl}/send-otp`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const resendOtp = async (data) => {
  const url = `${baseApiUrl}/resend-otp`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const validateOtp = async (data) => {
  const url = `${baseApiUrl}/validate-otp`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const validatePassword = async (data) => {
  const url = `${baseApiUrl}/features/validate-password`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getPortfolioDetails = async (custId) => {
  try {
    const response = await axios.get(
      `${baseApiUrl}/features/portfolio-detail?custId=${custId}`
    );
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getPortfolioSummary = async (custId) => {
  try {
    const response = await axios.get(
      `${baseApiUrl}/features/summary?custId=${custId}`
    );
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const updateCustomer = async (custId, data) => {
  const url = `${baseApiUrl}/customer/update?custId=${custId}`;
  try {
    const response = await axios.patch(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const updateAccountStatus = async (custId, data) => {
  const url = `${baseApiUrl}/customer/update-status?custId=${custId}`;
  try {
    const response = await axios.put(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const ViewDocumentList = async (custId, data) => {
  const url = `${baseApiUrl}/customer/documents?custId=${custId}`;
  try {
    const response = await axios.get(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const logout = async (data) => {
  const url = `${baseApiUrl}/log-out`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getFeaturesForUser = async () => {
  const url = `${baseApiUrl}/user/user-feature`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getUsers = async (query) => {
  const url = `${testApiUrl}/dashboard/user-search?query=${query}&pageSize=1000`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getTransactionList = async (userId, admin) => {
  const url = `${testApiUrl}/dashboard/get-transaction-list?admin=${admin}&userId=${userId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getAccounts = async (userId, accountType) => {
  const url = `${testApiUrl}/dashboard/accounts`;
  var params = { userId };
  if (accountType === "beneficiary") params["accountType"] = "beneficiary";
  else if (accountType === "remitter") params["accountType"] = "remitter";
  else if (accountType === "student") params["accountType"] = "student";

  try {
    const response = await axios.get(url, { params });
    return response;
  } catch (error) {
    return error.response;
  }
};

// export const recentTransaction = async (
//   startDate,
//   endDate,
//   partner,
//   orderBy = "",
//   orderByField,
//   status,
//   vendorQuoteId,
// ) => {
//   const url = `${testApiUrl}/dashboard/recent-transactions?orderByDirection=${orderBy}&orderByField=${orderByField}&pageNumber=1&pageSize=500&vendorQuoteId=${vendorQuoteId}&from=${startDate}&to=${endDate}&partner=${partner}&statusString=${status}`;
//   try {
//     const response = await axios.get(url);
//     return response;
//   } catch (error) {
//     return error.response;
//   }
// };
export const recentTransaction = async (
  startDate,
  endDate,
  partner,
  vendorQuoteId = "",
  orderBy = "",
  orderByField = "",
  status = "",
  searchData = ""
) => {
  const url = `${testApiUrl}/dashboard/recent-transactions?pageNumber=1&pageSize=500&vendorQuoteId=${vendorQuoteId}&searchData=${searchData}&from=${startDate}&to=${endDate}&partner=${partner}&statusString=${status}&orderByDirection=${orderBy}&orderByField=${orderByField}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const getAccountDetails = async (userId) => {
  const url = `${testApiUrl}/dashboard/accounts?userAccountId=${userId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getTransactionDetails = async (transactionId) => {
  const url = `${testApiUrl}/dashboard/get-transaction-list?admin=true&transactionId=${transactionId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getQuoteDetails = async (transactionId) => {
  const url = `${testApiUrl}/dashboard/transaction-details?transactionId=${transactionId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getBankAccount = async (accountId) => {
  const url = `${testApiUrl}/dashboard/bank?userAccountId=${accountId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getTransactionDocs = async (transactionId) => {
  const url = `${testApiUrl}/dashboard/docs?transactionId=${transactionId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getPartnerList = async () => {
  const url = `${testApiUrl}/dashboard/partner?pageNumber=1&pageSize=500`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getAllPartnerList = async (pageNumber = 1) => {
  const url = `${testApiUrl}/dashboard/partner?pageNumber=${pageNumber}&pageSize=500`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const addBankAccount = async (data) => {
  const url = `${baseApiUrl}/customer/bank/account`;
  try {
    const response = await axios.put(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const bankList = async (data) => {
  const url = `${baseApiUrl}/customer/bank`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createCoupons = async (data) => {
  const url = `${testApiUrl}/dashboard/coupon`;
  try {
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};
export const fetchCoupons = async (data) => {
  const url = `${testApiUrl}/dashboard/coupon`;
  try {
    const response = await axios.get(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const editCoupons = async (data) => {
  const url = `${testApiUrl}/dashboard/coupon`;
  try {
    const response = await axios.patch(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const getFeatureforRole = async (id) => {
  const url = `${baseApiUrl}/roles/fetch-role-features?dashboardRoleId=${id}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getPlanList = async () => {
  const url = `${testApiUrl}/dashboard/plans`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const partnerPlanList = async (partnerId) => {
  const url = `${testApiUrl}/dashboard/partner-plan?partnerCode=${partnerId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getInvestingPartnerList = async () => {
  const url = `${baseApiUrl}/partner-codes/list`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getStacksList = async (id) => {
  const url = `${baseApiUrl}/stacks/list?custId=${id}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const addNewBuyStack = async (id, data) => {
  const url = `${baseApiUrl}/stacks/trade-stack?custId=${id}`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const fetchOrders = async (id, data) => {
  const url = `${baseApiUrl}/stacks/user-stack-orders?custId=${id}`;
  try {
    const response = await axios.get(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const accountTransactions = async ({
  userId = "",
  custId = "",
  startDate = "",
  endDate = "",
  accountNo = "",
  selectedTransactionType = "",
  newOrder = "ASC",
  pageNumber = 1,
  pageSize = 20,
}) => {
  const url = `${baseApiUrl}/features/account-transactions/?custId=${custId}&userId=${userId}&startDate=${startDate}&endDate=${endDate}&accountNumber=${accountNo}&transactionType=${selectedTransactionType}&newOrder=${newOrder}&page=${pageNumber}&pageSize=${pageSize}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const userReport = async ({ startDate = "", endDate = "", partner,page = 1, pageSize = 20}) => {
  const url = `${baseApiUrl}/investing/report/user/generate?partnerCode=${partner}&from=${startDate}&to=${endDate}&page=${page}&pageSize=${pageSize}`;
  try {
    const response = await axios.post(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const paymentReport = async ({
  startDate = "",
  endDate = "",
  partner,
  page = 1, 
  pageSize = 20,
}) => {
  const url = `${baseApiUrl}/investing/report/payment/generate?partnerCode=${partner}&from=${startDate}&to=${endDate}&page=${page}&pageSize=${pageSize}`;
  try {
    const response = await axios.post(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getUserReportDownloadApi = async (page = 1, pageSize = 20, filterType = "User Reports", source) => {
  const url = `${baseApiUrl}/investing/report/user/filters?page=${page}&pageSize=${pageSize}&filterType=${filterType}&source=${source}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getTransactionReportDownloadApi = async (page = 1, pageSize = 20, filterType = "TRANSACTION_REPORT", source) => {
  const url = `${baseApiUrl}/investing/report/user/filters?page=${page}&pageSize=${pageSize}&filterType=${filterType}&source=${source}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getPaymentReportDownloadApi = async (page = 1, pageSize = 20, filterType = "Payment Reports", source) => {
  const url = `${baseApiUrl}/investing/report/user/filters?page=${page}&pageSize=${pageSize}&filterType=${filterType}&source=${source}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getPartnerDetails = async (erPartnerId, data) => {
  const url = `${testApiUrl}/dashboard/partner?erPartnerId=${erPartnerId}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createNewPartner = async (data) => {
  const url = `${testApiUrl}/dashboard/partner`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const getPartnerPlanList = async (partnerCd) => {
  const url = `${testApiUrl}/dashboard/partner-plan?partnerCode=${partnerCd}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createPartnerPlan = async (data) => {
  const url = `${testApiUrl}/dashboard/partner-plan`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createPlan = async (data) => {
  const url = `${testApiUrl}/dashboard/plan`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updatePlans = async (data) => {
  const url = `${testApiUrl}/dashboard/plan`;
  try {
    const response = await axios.put(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const updatePartner = async (erPartnerId, data) => {
  const url = `${testApiUrl}/dashboard/partner?erPartnerId=${erPartnerId}`;
  try {
    const response = await axios.patch(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const getVendorList = async () => {
  const url = `${testApiUrl}/dashboard/getVendors`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getPlanDetails = async (erPlanId, data) => {
  const url = `${testApiUrl}/dashboard/plans/planId?erPlanId=${erPlanId}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const usersList = async (
  currentPage = 1,
  pageSize = 20,
  length,
  filter = ""
) => {
  const url = `${baseApiUrl}/user/user-list?currentPage=${currentPage}&pageSize=${pageSize}&length=${length}&filter=${filter}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateUserFeatures = async (data) => {
  const url = `${baseApiUrl}/roles/update`;
  try {
    const response = await axios.patch(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const editUserRole = async (data) => {
  const url = `${baseApiUrl}/user/add-user-role`;
  try {
    const response = await axios.patch(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const SubscriptionDetails = async (custId, data) => {
  const url = `${baseApiUrl}/customer/subscription?custId=${custId}`;
  try {
    const response = await axios.get(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};
export const getErPartnerList = async () => {
  const url = `${testApiUrl}/dashboard/partner-list`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const activityLoggerList = async (
  pageSize = 20,
  pageNumber = 1,
  filters = {}
) => {
  const {
    requestId,
    actionType,
    servicesName,
    env,
    errorCode,
    searchData,
    startDate,
    endDate,
    appName,
  } = filters;

  const url = `${baseApiUrl}/activity/logger?pageSize=${pageSize}&pageNumber=${pageNumber}&requestId=${
    requestId || ""
  }&actionType=${actionType || ""}&servicesName=${servicesName || ""}&env=${
    env || ""
  }&errorCode=${errorCode || ""}&searchData=${searchData || ""}&startDate=${
    startDate || ""
  }&endDate=${endDate || ""}&appName=${appName || ""}`;

  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const ordersList = async (
  startDate,
  endDate,
  partner,
  fetchBy,
  search = "",
  symbol,
  category,
  page = 1,
  pageSize = 20
) => {
  const url = `${baseApiUrl}/features/order-list?fromDate=${startDate}&toDate=${endDate}&partnerCode=${partner}&fetchBy=${fetchBy}&search=${
    search || ""
  }&symbol=${symbol || ""}&category=${
    category || ""
  }&page=${page}&pageSize=${pageSize}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getOrdersDetails = async (orderId) => {
  const url = `${baseApiUrl}/features/order-details?orderId=${orderId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

// MCB
export const getMcbUsers = async (
  username,
  page = 1,
  pageSize = 20,
  filters = ""
) => {
  const url = `${mcbApiUrl}/dashboard/user?searchText=${username}&page=${page}&pageSize=${pageSize}&filters=${filters}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const mcbtransaction = async (userID, page = 1, pageSize = 20) => {
  const url = `${mcbApiUrl}/dashboard/user/transaction?userId=${userID}&page=${page}&pageSize=${pageSize}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const mcbLienTransaction = async (userID, page = 1, pageSize = 20) => {
  const url = `${mcbApiUrl}/dashboard/partner/transaction?userId=${userID}&page=${page}&pageSize=${pageSize}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const mcbBeneficiary = async (userID, page = 1, pageSize = 20) => {
  const url = `${mcbApiUrl}/dashboard/user/beneficiary?userId=${userID}&page=${page}&pageSize=${pageSize}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const mcbGlobalAccount = async (userID, data) => {
  const url = `${mcbApiUrl}/dashboard/user/global?userId=${userID}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const mcbPartnerAccount = async (userID, data) => {
  const url = `${mcbApiUrl}/dashboard/user/globallien?userId=${userID}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const mcbWallets = async (userID, data) => {
  const url = `${mcbApiUrl}/dashboard/user/Wallet?userId=${userID}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const mcbPartnerWallets = async (userID, data) => {
  const url = `${mcbApiUrl}/dashboard/user/partner-wallet?userId=${userID}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getMcbUsersDetails = async (userId) => {
  const url = `${mcbApiUrl}/dashboard/user?userId=${userId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const getMcbvendorDetails = async (userId) => {
  const url = `${mcbApiUrl}/dashboard/user/vendor-client/${userId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const mcbAllTransactions = async (
  searchText = "",
  currency = "",
  status = "",
  fromDate = "",
  toDate = "",
  page = 1,
  pageSize = 20,
  accountType = "",
  partner = "",
) => {
  const url = `${mcbApiUrl}/dashboard/user/transaction?searchText=${searchText}&currency=${currency}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&page=${page}&pageSize=${pageSize}&accountType=${accountType}&partnerCode=${partner}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

// users partner
export const getUsersPartnerList = async (data) => {
  const url = `${baseApiUrl}/partner-codes/partners`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getPartnerPlan = async (partnerCode) => {
  const url = `${baseApiUrl}/partner-codes/${partnerCode}/plans`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const AddPartnerPlan = async (data) => {
  const url = `${baseApiUrl}/customer/partner/mapping`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

//portfolio clear and regenerate

export const clearPortfolio = async (custId, category, symbol) => {
  try {
    const response = await axios.post(
      `${baseApiUrl}/features/clean-regenerate`,
      {
        custId: custId,
        category: category,
        symbol: symbol
      }
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};


export const regeneratePortfolio = async (custId, category, symbol) => {
  try {
    const response = await axios.post(
      `${baseApiUrl}/features/regenerate`,
      {
        custId: custId, 
        category: category,
        symbol: symbol
      }
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const regenerateAllPortfolio = async (custId, category, symbol) => {
  try {
    const response = await axios.post(
      `${baseApiUrl}/features/regenerate`,
      {
        custId: custId, 
        category: "all",
        symbol: "all"
      }
    );
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// Follow up
export const getFollowUpList = async (custId) => {
  const url = `${baseApiUrl}/follow-up/?custId=${custId}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    return error.response;
  }
};
export const addNewFollowup = async (data) => {
  const url = `${baseApiUrl}/follow-up/`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const editFollowup = async (followups_id, data) => {
  const url = `${baseApiUrl}/follow-up/?followups_id=${followups_id}`;
  try {
    const response = await axios.patch(url, data, followups_id);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const addFollowupHistory = async (data) => {
  const url = `${baseApiUrl}/follow-up/history`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

// investing partners api's
export const getInvestingPartners = async (page = 1, pageSize = 20, filter = "") => {
  const url = `${baseApiUrl}/partner-codes/partner-list?pageNo=${page}&pageSize=${pageSize}&filter=${filter}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    return error.response;
  }
};


export const getInvestingPartnerDetails = async (partnerCd, data) => {
  const url = `${baseApiUrl}/partner-codes/partner-details?partnerCd=${partnerCd}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createNewInvestingPartner = async (data) => {
  const url = `${baseApiUrl}/partner-codes/add-partner`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateInvestingPartner = async (partnerCd, data) => {
  const url = `${baseApiUrl}/partner-codes/update-partner?partnerCd=${partnerCd}`;
  try {
    const response = await axios.patch(url, data, partnerCd);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// partner config 
export const PartnerConfigList = async (category, data) => {
  const url = `${baseApiUrl}/partner-codes/config-list?category=${category}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const UpdatePartnerConfig = async (data) => {
  const url = `${baseApiUrl}/partner-codes/update-partner-config`;
  try {
    const response = await axios.patch(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const UploadDocument = async (data) => {
  const url = `${baseApiUrl}/plan/upload-doc`;
  
  try {
    const response = await axios.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const bulkPlanMigration = async (data) => {
  const url = `${baseApiUrl}/plan/bulk-plan-migration`;
  try {
    const response = await axios.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};


export const mcbAddBeneficiaryList = async () => {
  const url = `${mcbApiUrl}/dashboard/hedgeFundBeneficiary`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const mcbAddBeneficiary = async (data) => {
  const url = `${mcbApiUrl}/dashboard/hedgeFundBeneficiary`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getAccountNumber = async (stoUserBankId) => {
  const url = `${baseApiUrl}/customer/bank/acc-no?stoUserBankId=${stoUserBankId}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    return error.response;
  }
};
export const deleteAccount = async (id, data) => {
  const url = `${baseApiUrl}/customer/bank/account/${id}`;
  try {
    const response = await axios.put(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

// plan 
export const createNewPlan = async (data) => {
  const url = `${baseApiUrl}/plan`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updatePlan = async (planCode, data) => {
  const url = `${baseApiUrl}/plan`;
  try {
    const response = await axios.patch(url, data, planCode);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const getPlans = async (page = 1, pageSize = 20, searchText = "") => {
  const url = `${baseApiUrl}/plan?page=${page}&pageSize=${pageSize}&searchText=${searchText}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getPlansDetails = async (code, data) => {
  const url = `${baseApiUrl}/plan?code=${code}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const CreateplanConfig = async (data) => {
  const url = `${baseApiUrl}/plan/plan-config`;
  try {
    const response = await axios.patch(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getComponentList = async (source) => {
  const url = `${baseApiUrl}/features/component?source=${source}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getnewFeatureList = async (data) => {
  const url = `${baseApiUrl}/features/new-feature`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getRefreshFeatureList = async (data) => {
  const url = `${baseApiUrl}/features/role-feature`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getUsersFeature= async (username) => {
  const url = `${baseApiUrl}/features/role-feature?username=${username}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const closeMcbAccount = async (data) => {
  const url = `${mcbApiUrl}/dashboard/close-account`;
  try {
    const response = await axios.patch(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const generateReport = async ({ startDate = "", endDate = "", partner,page = 1, pageSize = 20, source, reportType, accountType}) => {
  const url = `${baseApiUrl}/report/download-report?partnerCode=${partner}&startDate=${startDate}&endDate=${endDate}&page=${page}&pageSize=${pageSize}&reportType=${reportType}&source=${source}&accountType=${accountType}`;
  try {
    const response = await axios.post(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const mcbDocumentList = async (userId, data) => {
  const url = `${mcbApiUrl}/dashboard/user/doc?userId=${userId}`;
  try {
    const response = await axios.get(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const mcbDocumentView = async (userId, data) => {
  const url = `${mcbApiUrl}/dashboard/user/view-doc?userId=${userId}&userDocId=${data}`;
  try {
    const response = await axios.get(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const closeInvestingAccount = async (custId, data) => {
  const url = `${baseApiUrl}/customer/${custId}/close`;
  try {
    const response = await axios.patch(url, data);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const getAnnualPnlStatement = async (type, year, period, custId, accountNo) => {
  const urlupdate =
    type === "annual"
      ? `${pnlURL}?type=${type}&endYear=${year}&period=${period}&custId=${custId}&accountNo=${accountNo}`
      : `${pnlURL}?type=${type}&endYear=${year}&month=${period}&custId=${custId}&accountNo=${accountNo}`;

  const options = {
    method: "GET",
    url: urlupdate,
    responseType: "blob",
    headers: {
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  };

  return axios(options)
    .then((response) => {
      if (response.status === 200) {
        return response;
      }
      throw response;
    })
    .catch((error) => {
      throw error;
    });
};

export const countryList = async (data) => {
  const url = `${InvestingApiUrl}/site/list?type=residence`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateTrustedContact = async (data, custId) => {
  const url = `${baseApiUrl}/customer/trusted-contact?custId=${custId}`;
  try {
    const response = await axios.patch(url, data);
    if (response.data && response.data.code === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

export const createNewEvent = async (data) => {
  const url = `${baseApiUrl}/customer/event`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const fetchNewEvent= async (data, applicationName) => {
  const url = `${baseApiUrl}/customer/event/list`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const createNewCoupon = async (data) => {
  const url = `${baseApiUrl}/coupons`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateCoupon = async (data, code) => {
  const url = `${baseApiUrl}/coupons/${code}`;
  try {
    const response = await axios.patch(url, data);
    if (response.data && response.data.code === 200) {
      return response.data;
    }
  } catch (error) {
    return error.response;
  }
};

export const getAllCoupons = async (
  searchText = "",
  status = "",
  startDate = "",
  endDate = "",
  page = 0, 
  pageSize = 20,
) => {
  const url = `${baseApiUrl}/coupons?status=${status}&startDate=${startDate}&endDate=${endDate}&searchText=${searchText}&page=${page}&pageSize=${pageSize}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getCouponsDetails = async (code, data) => {
  const url = `${baseApiUrl}/coupons?code=${code}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const planDeductionReport = async (data) => {
  const url = `${baseApiUrl}/investing/report/plan/plan-deduction-list`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};


export const lienReportDownload = async (data) => {
  const url = `${mcbApiUrl}/dashboard/user/statement-letter?download=true`;
  try {
    const response = await axios.post(url, data, {
      responseType: "arraybuffer",
    });
       return response;
  } catch (error) {
    return error.response;
  }
};

export const transactionReportDownload = async (data, transactionNo) => {
  const url = `${mcbApiUrl}/dashboard/user/transaction/receipt?transactionNo=${transactionNo}`;

  try {
    const response = await axios.get(url, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const accountStatementDownload = async (userId, accountType, fromDate, toDate, currency) => {
  const url = `${mcbApiUrl}/dashboard/account-statement?userId=${userId}&accountType=${accountType}&fromDate=${fromDate}&toDate=${toDate}&currency=${currency}`;

  try {
    const response = await axios.get(url, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const balanceConfirmationDownload = async (userId, accountType) => {
  const url = `${mcbApiUrl}/dashboard/balance-confirmation?userId=${userId}&accountType=${accountType}`;

  try {
    const response = await axios.get(url, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const lienCountryList = async (data, userId) => {
  const url = `${mcbApiUrl}/dashboard/beneficiary/country?userId=${userId}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const lienBeneCountryList = async (data, currency, country, userId, method) => {
  const url = `${mcbApiUrl}/dashboard/bene-country-config?currency=${currency}&country=${country}&userId=${userId}${method ? `&method=${method}` : ""}`;
  try {
    const response = await axios.get(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const AddNewBeneficiary = async (data) => {
  const url = `${mcbApiUrl}/dashboard/beneficiary-lien`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const LienBeneficiary = async (userID, page = 1, pageSize = 20, status) => {
  const url = `${mcbApiUrl}/dashboard/beneficiary-lien?page=${page}&pageSize=${pageSize}&userId=${userID}&status=${status}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const WalletTransfer = async (userId, accountType) => {
  const url = `${mcbApiUrl}/dashboard/user/Wallet?userId=${userId}&accountType=GLOBAL_LIEN`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const TransferFee = async (
  buyAmount,
  sellAmount,
  toCurrency,
  fromCurrency,
  method,
  transactionType,
  country,
  userId
) => {
  const params = {
    toCurrency,
    fromCurrency,
    transactionType,
    method,
    country,
    userId,
  };

  if (sellAmount !== undefined && sellAmount !== null) {
    params.sellAmount = sellAmount;
  }
  if (buyAmount !== undefined && buyAmount !== null) {
    params.buyAmount = buyAmount;
  }

  const query = new URLSearchParams(params).toString();
  const url = `${mcbApiUrl}/dashboard/fee?${query}`;

  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const ExecuteTransfer = async (data) => {
  const url = `${mcbApiUrl}/dashboard/lien-transaction/initiate`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const LienBeneficiaryDetails = async (beneficiaryId) => {
  const url = `${mcbApiUrl}/dashboard/beneficiary-lien?beneficiaryId=${beneficiaryId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const partnerRatesChange = async (data) => {
  const url = `${mcbApiUrl}/dashboard/partner-rates`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const partnerRates = async (partnerCode) => {
  const url = `${mcbApiUrl}/dashboard/partner-rates?partnerCode=${partnerCode}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const lienToUnlienTransfer = async (data) => {
  const url = `${mcbApiUrl}/dashboard/internal-transfer`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const emiDeductionWallet = async (data) => {
  const url = `${mcbApiUrl}/dashboard/charge-deduction`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const uploadDocument = async (custId, data) => {
  const url = `${baseApiUrl}/customer/document/upload?custId=${custId}`;
  try {
    const response = await axios.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};



export const getDocumentSchema  = async (country, custId) => {
  const url = `${baseApiUrl}/customer/document/schema?country=${country}&custId=${custId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const reKyc = async (custId,data) => {
  const url = `${baseApiUrl}/customer/document/re-kyc?custId=${custId}`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const mcbPartnerBeneficiary = async (page = 1, pageSize = 20) => {
  const url = `${mcbApiUrl}/dashboard/partner-beneficiary?page=${page}&pageSize=${pageSize}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const mcbPartnerAddBeneficiary = async (data) => {
  const url = `${mcbApiUrl}/dashboard/partner-beneficiary`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const mcbPartnerAddBeneficiaryList = async (userId) => {
  const url = `${mcbApiUrl}/dashboard/user/partner-beneficiary?userId=${userId}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const mcbUserAddBeneficiary = async (data) => {
  const url = `${mcbApiUrl}/dashboard/user/partner-beneficiary`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const CountrylistMca = async (partnerCode) => {
  const url = `${mcbApiUrl}/dashboard/beneficiary/country/partner?partnerCode=${partnerCode}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const StatelistMca = async (countryCode) => {
  const url = `${mcbApiUrl}/dashboard/beneficiary/states?countryCode=${countryCode}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const WalletConversion = async (userId, data) => {
  const url = `${mcbApiUrl}/dashboard/wallet/transfer?userId=${userId}`;

  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};
export const WalletLienConversion = async (userId, data) => {
  const url = `${mcbApiUrl}/dashboard/lien-wallet/transfer?userId=${userId}`;

  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const deletebeneficiary = async (beneficiaryId) => {
  const url = `${mcbApiUrl}/dashboard/partner-beneficiary?beneficiaryId=${beneficiaryId}`;
  try {
    const response = await axios.delete(url);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export const mcbBeneficiaryList = async (page = 1, pageSize = 20) => {
  const url = `${mcbApiUrl}/dashboard/beneficiary?page=${page}&pageSize=${pageSize}&status=MANUAL_REVIEW`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

// Omit `status` to only save a comment and leave the beneficiary in review.
export const mcbBeneficiaryAction = async (beneficiaryId, status, comment) => {
  const url = `${mcbApiUrl}/dashboard/beneficiary/status`;
  const body = status
    ? { beneficiaryId, status, comment }
    : { beneficiaryId, comment };
  try {
    const response = await axios.patch(url, body);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const commisionStatus  = async (userId, country, method) => {
  const url = `${mcbApiUrl}/dashboard/user/commission?userId=${userId}&country=${country}&method=${method}`;
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const changeCommissionStatus = async (data) => {
  const url = `${mcbApiUrl}/dashboard/commission/free`;

  try {
    const response = await axios.patch(url, data);
    return response;
  } catch (error) {
    return error.response;
  }
};
